import { Component, inject, input, signal, viewChild } from '@angular/core';
import { FormComponent, UiComponentsModule } from '@mwe/ui/components';
import { NgClass } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IPopupModelV2, ModalChild } from '@mwe/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UmmeldungStore } from '../../store';
import { WIZARD_CONTROLLER, WizardBeforeNavigationEvent, WizardEventType } from '@mwe/features/wizard';
import { IkpPopupService } from '@shared-ikp/service/popup/popup.service';

@Component({
  selector: 'ikp-verify-save-ummeldung-popup',
  standalone: true,
  imports: [UiComponentsModule, ReactiveFormsModule, NgClass],
  templateUrl: './ummeldung-save-popup.component.html',
})
export class UmmeldungSavePopupComponent implements ModalChild {
  private readonly wizardController = inject(WIZARD_CONTROLLER);
  private readonly popupService = inject(IkpPopupService);

  formComponent = viewChild(FormComponent);
  popupModel = signal<IPopupModelV2>(null);
  size = input<'small' | 'large'>('large');

  private readonly activeModal = inject(NgbActiveModal);
  private readonly ummeldungStore = inject(UmmeldungStore);

  submit(): void {
    //We need to trigger the BeforeNextStepNavigation event to ensure that all steps have the chance to update the store with their current form values before we save the Ummeldung.
    this.wizardController.events$.next(
      new WizardBeforeNavigationEvent(WizardEventType.BeforeNextStepNavigation, this.wizardController.currentStep()),
    );

    this.ummeldungStore.saveActiveUmmeldung().subscribe({
      next: () => this.activeModal.close('OK'),
      error: () => {
        console.error('[UmmeldungSavePopupComponent] Error saving Ummeldung');
        this.popupService.handleErrorPopup(
          'save-ummeldung-error',
          'ummeldung.saveErrorPopup.title',
          'ummeldung.saveErrorPopup.message',
          true,
        );
      },
    });
  }

  closeWithoutSaving(): void {
    this.activeModal.close('CANCEL');
  }

  cancelPopup(): void {
    this.activeModal.dismiss('CANCEL');
  }
}
